"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IndustrialSales() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: ledeRef,
    isVisible: ledeVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="11444" id="industrial-sales-force" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32 lg:py-44">
      <div className="mx-auto w-full max-w-[1240px] px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 lg:gap-6 items-center">
          {}
          <div className="lg:col-span-7 lg:pr-8 order-2 lg:order-1 mt-12 lg:mt-0">
            <h1 ref={headlineRef} className="font-default font-bold text-foreground" style={{
            fontSize: "clamp(2.75rem, 5.4vw + 0.5rem, 5.25rem)",
            letterSpacing: "-0.025em",
            lineHeight: "1.02",
            opacity: headlineVisible ? 1 : 0,
            transform: headlineVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 900ms cubic-bezier(0.2, 0.7, 0.2, 1), transform 900ms cubic-bezier(0.2, 0.7, 0.2, 1)"
          }}>
              Precision sales for{" "}
              <span className="font-default italic text-primary" style={{
              opacity: headlineVisible ? 1 : 0,
              transition: "opacity 700ms cubic-bezier(0.2, 0.7, 0.2, 1) 200ms",
              display: "inline-block"
            }}>
                industrial
              </span>{" "}
              leaders.
            </h1>

            <p ref={ledeRef} className="font-default text-foreground/80 mt-20" style={{
            fontSize: "clamp(1.125rem, 0.4vw + 1.05rem, 1.3125rem)",
            lineHeight: "1.55",
            letterSpacing: "-0.005em",
            maxWidth: "52ch",
            opacity: ledeVisible ? 1 : 0,
            transform: ledeVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 720ms cubic-bezier(0.2, 0.7, 0.2, 1) 300ms, transform 720ms cubic-bezier(0.2, 0.7, 0.2, 1) 300ms"
          }}>
              MetPro Partners bridges the gap between elite manufacturers and industrial buyers, delivering technical authority and proven sales reach across automotive, metal, and safety sectors.
            </p>

            <div ref={ctaRef} className="mt-12 flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-8" style={{
            opacity: ctaVisible ? 1 : 0,
            transform: ctaVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 720ms cubic-bezier(0.2, 0.7, 0.2, 1) 480ms, transform 720ms cubic-bezier(0.2, 0.7, 0.2, 1) 480ms"
          }}>
              <Button asChild className="group relative bg-accent hover:bg-accent text-accent-foreground font-default font-bold px-7 py-7 h-auto text-sm tracking-normal shadow-md">
                <Link to="/ContactPage">
                  <span className="relative inline-block">
                    Request Partnership
                    <span aria-hidden="true" className="absolute left-0 -bottom-1 h-px bg-foreground transition-all duration-300 ease-out group-hover:w-full" style={{
                    width: "60%"
                  }} />
                  </span>
                </Link>
              </Button>

              <Link to="/ServicesPage" className="group inline-flex items-center font-default italic text-foreground text-base md:text-lg">
                <span className="relative inline-block">
                  Explore Our Capabilities
                  <span aria-hidden="true" className="absolute left-0 -bottom-1 h-px bg-accent transition-all duration-300 ease-out w-0 group-hover:w-full origin-left" />
                </span>
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 order-1 lg:order-2">
            <div ref={imageRef} className="relative w-full overflow-hidden" style={{
            aspectRatio: "4 / 5",
            opacity: imageVisible ? 1 : 0,
            transform: imageVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 900ms cubic-bezier(0.2, 0.7, 0.2, 1) 200ms, transform 900ms cubic-bezier(0.2, 0.7, 0.2, 1) 200ms",
            boxShadow: "inset 0 0 0 1px hsla(0, 0%, 49%, 0.5)"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/industrial_precision_machining.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/industrial_precision_machining.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/industrial_precision_machining.webp-wvc-sizes" alt="High-precision industrial machining process in a controlled environment" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" />
              <div aria-hidden="true" className="absolute inset-x-0 bottom-0 h-2/5" style={{
              background: "linear-gradient(to bottom, hsla(0, 0%, 3%, 0) 0%, hsla(0, 0%, 3%, 0.8) 100%)"
            }} />
            </div>
          </div>
        </div>
      </div>
    </section>;
}